import React from "react";
import DigitalVolunteerForm from "./DigitalVolunteerForm";
import "./DigitalVolunteer.style.css";
import ReactMarkdown from "react-markdown";
import WebData from "../../../../Helpers/WebData";

const DigitalVolunteer = () => {
  const paragraph =
    "Whether you are a student, a doctor, a lawyer, an accountant, a computer specialist, an organic farming or a dairy expert or have a solid social media presence, write to us. We encourage flexible timings. You can change the world, right from your home";
  return (
    <>
      <section id="digitalVolunteerTab">
        <div className="custom-row">
          <div className="engage-container gm-content-wrapper content-view1">
            <div className="scrollbar-hide gm-para">
              <p className="justify-desc mb-0">
                <ReactMarkdown>{paragraph}</ReactMarkdown>
              </p>
            </div>
            <div className="scrollbar-hide">
              <DigitalVolunteerForm />
            </div>
          </div>
          <div className=" d-flex align-items-center justify-content-center gm-image image-view1">
            <div className="gm-img">
              <img
                className="d-flex"
                src={WebData.digitalVolunteerImg}
                alt="digital-volunteer-image"
                srcset=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DigitalVolunteer;
